<template>
  <div class="uploadSong">
    <audio id="up_audio" :src="mp3Url" style="display: none;"></audio>
    <div class="bar">
      <div class="btn">上 传 歌 曲</div>
      <Bar :type="type"></Bar>
    </div>
    <div class="form">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="350px"
        class="demo-ruleForm"
      >
        <el-form-item label="歌名" prop="productionName">
          <el-input v-model="ruleForm.productionName" placeholder="输入歌名"></el-input>
        </el-form-item>
        <el-form-item label="是否仅自己可见" prop="isPrivate">
          <el-radio-group v-model="ruleForm.isPrivate">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="歌曲封面" prop="coverUrl">
          <el-upload
            style="line-height: 0;padding-bottom: 12px;"
            class="avatar-uploader"
            accept="image/jpg, image/jpeg, image/png, image/bmp"
            action="/api/oss/upload"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="ruleForm.coverUrl" :src="ruleForm.coverUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="歌曲风格" prop="songType">
          <el-select v-model="ruleForm.songType" placeholder="请选择分类">
            <el-option
              v-for="item in options"
              :key="item.codeId"
              :label="item.codeName"
              :value="item.codeId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上传音频" prop="fileList">
          <el-upload
            class="upload-demo"
            action="/api/oss/musicUpload"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            accept="audio/mpeg, audio/wav, audio/mp4, video/mp4, audio/mpeg, video/mpeg, audio/3gpp, video/3gpp, audio/ac3, audio/basic"
            :on-change="handleChange"
            :on-success="successMp"
            :before-remove="beforeRemove"
            multiple
            :on-exceed="handleExceed"
            :file-list="ruleForm.fileList"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="上传歌词">
          <upLyric v-on:upLyricData="getLrc"></upLyric>
        </el-form-item>
        <el-form-item prop="checked">
          <el-checkbox v-model="ruleForm.checked">
            <a target="_blank" href="https://win.richandyoung.cn/8MILE/publish.html">关于发布作品的版权协议</a>
          </el-checkbox>
        </el-form-item>
        <el-form-item style="margin-bottom: 50px;margin-top: 15px;">
          <el-button @click="submitForm('ruleForm')">保存</el-button>
          <el-button @click="resetForm('ruleForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
let Base64 = require("js-base64").Base64;
import upLyric from "../components/upLrc";
import { uploadFreeMusic } from "@/api/personal";
import { setLocalStorage, getLocalStorage } from "@/utils/localStorage";
import Bar from "../components/bars";
export default {
  components: { Bar, upLyric },
  name: "uploadSong",
  data() {
    let check = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请同意版权协议"));
      } else {
        callback();
      }
    };
    return {
      mp3Src: "",
      upImgSrc: "",
      mp3Url: "",
      fileSize: 0,
      mp3Size: 0,
      mp3Time: 0,
      mp3Kbsp: 0,
      type: "song",
      value1: "",
      imageUrl: "",
      wordsUrl: "",
      ruleForm: {
        domains: [
          {
            value: "",
          },
        ],
        checked: false,
        productionName: "",
        coverUrl: "",
        songType: "",
        receiptType: "",
        pricing: "",
        fileList: [],
        issue: "",
        isPrivate: "",
        wordsUrl: "",
        ususSourceMd5: "",
      },
      rules: {
        productionName: [
          { required: true, message: "输入歌曲名", trigger: "change" },
        ],
        isPrivate: [
          {
            required: true,
            message: "请选择是否仅自己可见",
            trigger: "change",
          },
        ],
        coverUrl: [
          { required: true, message: "请上传歌曲封面图", trigger: "change" },
        ],
        songType: [
          { required: true, message: "请选择类型", trigger: "change" },
        ],
        fileList: [
          { required: true, message: "请上传音频", trigger: "change" },
        ],
        checked: [{ validator: check, trigger: "blur" }],
      },
      options: JSON.parse(getLocalStorage("getType")),
    };
  },
  methods: {
    getLrc(data) {
      this.wordsUrl = data;
    },
    s_to_hs(s) {
      //计算分钟
      //算法：将秒数除以60，然后下舍入，既得到分钟数
      var h;
      h = Math.floor(s / 60);
      //计算秒
      //算法：取得秒%60的余数，既得到秒数
      s = Math.floor(s % 60);
      //将变量转换为字符串
      h += "";
      s += "";
      //如果只有一位数，前面增加一个0
      h = h.length == 1 ? "0" + h : h;
      s = s.length == 1 ? "0" + s : s;
      return h + ":" + s;
    },
    handleChange(file, fileList) {
      // this.mp3Url = file.url
      // this.mp3Size = Math.floor((file.size/1024/1024)*100)/100
      this.ruleForm.fileList = fileList.slice(-1);
    },
    successMp(response, file, fileList) {
      let du = document.getElementById("up_audio");
      this.mp3Url = "https://show.richandyoung.cn/" + response.data.sourceUrl;
      this.ruleForm.ususSourceMd5 = response.data.sourceMd5;
      du.src = this.mp3Url;
      this.mp3Size = Math.floor((file.size / 1024 / 1024) * 100) / 100;
      this.fileSize = file.size;
      let that = this;
      du.oncanplay = function () {
        that.mp3Src = response.data.sourceUrl;
        that.mp3Time = that.s_to_hs(du.duration);
        let kbps = parseInt((file.size * 8) / du.duration / 1024);
        let s = parseInt(kbps / 32) * 32;
        //this.mp3Size = this.mp3Size + 'MB'
        that.mp3Kbsp = s + "kbps";
        console.log(that.mp3Kbsp);
      };
    },
    handleAvatarSuccess(res, file) {
      this.upImgSrc = res.data.sourceUrl;
      this.ruleForm.coverUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 200;

      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 200MB!");
      }
      // return isJPG && isLt2M;
      return isLt2M;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    getCaption(obj) {
      var index = obj.lastIndexOf(".cn/");
      obj = obj.substring(index + 4, obj.length);
      return obj;
    },
    submitForm(formName) {
      if (Base64.encode(this.ruleForm.productionName).indexOf("/") != -1) {
        this.$message.error("歌曲名不合法，可能含有特殊字符");
        return false;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.mp3Kbsp == "NaNkbps") {
            let du = document.getElementById("up_audio");
            du.src = this.mp3Url;
            this.mp3Size =
              Math.floor((this.fileSize / 1024 / 1024) * 100) / 100;
            let that = this;
            du.oncanplay = function () {
              that.mp3Time = that.s_to_hs(du.duration);
              let kbps = parseInt((that.fileSize * 8) / du.duration / 1024);
              let s = parseInt(kbps / 32) * 32;
              that.mp3Kbsp = s + "kbps";
              console.log(that.mp3Kbsp);
            };
          }
          if (this.mp3Src == "") {
            this.$message.error("音频正在上传中，请耐心等待");
            return false;
          }
          if (this.wordsUrl == "" && this.$store.state.app.addLrc != "") {
            this.$message.error("请先点击右下角确认，生成歌词文件");
            return false;
          }
          this.ruleForm.size = this.mp3Size + "MB";
          this.ruleForm.bitrate = this.mp3Kbsp;
          this.ruleForm.mins = this.mp3Time;
          this.ruleForm.styleId = this.ruleForm.songType;
          this.ruleForm.sourceUrl = this.mp3Src;
          this.ruleForm.coverUrl = this.upImgSrc;
          this.ruleForm.wordsUrl = this.wordsUrl;
          this.ruleForm.isAccompany = 0;
          uploadFreeMusic(this.ruleForm)
            .then((res) => {
              this.$message({
                message: "保存成功",
                type: "success",
              });
              this.$refs[formName].resetFields();
              this.$router.go(-1);
            })
            .catch((err) => {
              this.$router.go(-1);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    close() {
      this.$router.go(-1);
    },
    resetForm(formName) {
      this.$router.go(-1);
      //his.$refs[formName].resetFields();
    },
  },
};
</script>

<style scoped lang="scss">
.uploadSong {
  font-family: Tahoma, Arial, "Helvetica Neue", "Hiragino Sans GB", Simsun,
    sans-self;
  display: flex;
  width: 1136px;
  height: auto;
  margin: 25px auto;
  .bar {
    width: 175px;
    height: 554px;
    border-right: 2px solid #a3f310;
    .btn {
      width: 177px;
      height: 47px;
      background: #a3f310;
      line-height: 47px;
      text-align: center;
      font-size: 25px;
      color: #fff;
    }
  }
  .form {
    width: 946px;
    min-height: 550px;
    border: 2px solid #a3f310;
    margin-left: 8px;
    position: relative;
    .add {
      position: absolute;
      top: -20px;
      right: 260px;
      cursor: pointer;
    }
    .add:hover {
      color: #a3f310;
    }
  }
}
</style>
<style rel="stylesheet/scss" lang="scss">
.form {
  .el-upload-list {
    width: 340px;
  }
  .avatar {
    max-width: 340px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    margin-top: 10px;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .upload-demo {
    margin-bottom: 8px;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 70px;
    height: 70px;
    line-height: 70px;
    text-align: center;
  }
  .el-input {
    width: 340px;
    font-size: 16px;

    .el-input__inner {
      height: 30px;
      line-height: 30px;
      border-radius: 5px;
      font-family: Tahoma, Arial, "Helvetica Neue", "Hiragino Sans GB", Simsun,
        sans-self;
    }
  }

  .el-form-item__label {
    color: #a3f310;
    font-size: 16px;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #a3f310;
  }

  .demo-ruleForm {
    padding-top: 25px;
  }

  .el-form-item {
    margin-bottom: 10px;
  }

  .el-radio__label {
    font-size: 16px;
  }

  .el-button {
    width: 120px;
    height: 37px;
    background: #a3f310;
    border-radius: 10px;
    color: #fff;
    border: 1px solid #a3f310;
    font-size: 16px;
    padding: 0;
    margin-right: 90px;
  }

  .el-form-item__error {
    padding-top: 0px;
    top: 96%;
  }

  .el-form-item.is-success .el-input__inner {
    border-color: transparent;
  }
  .el-checkbox__label a {
    color: #a3f310;
  }
  .el-checkbox__label > a:hover {
    text-decoration: underline;
  }
  .el-form-item__error {
    top: 88%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/uploadSong.vue